var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Divider, Toolbar, AppBar, CssBaseline, Drawer, useMediaQuery, IconButton, useTheme, Hidden, Tooltip, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Brightness4, Brightness7, Menu } from "@material-ui/icons";
import { paths } from "frontend/src/pages/paths/index";
import { Navigation } from "./navigation";
import { Breadcrumbs } from "./breadcrumbs";
import { Logo } from "frontend/src/ui/logo";
import { Player } from "../../../features/show-player";
import { useThemeMode } from "frontend/src/shared/theme-mode";
var drawerWidth = 260;
var useStyles = makeStyles(function (theme) { return ({
    toolbar: __assign(__assign({}, theme.mixins.toolbar), { height: 83 }),
    appBar: {
        marginLeft: drawerWidth,
        width: "calc(100% - " + drawerWidth + ")",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    main: __assign(__assign({ flexGrow: 1, backgroundColor: theme.palette.background.default, color: theme.palette.text.primary, padding: theme.spacing(3), paddingBottom: 140, width: "100%", "& .MuiPaper-root, & .MuiTableCell-root, & .MuiTypography-root, & .MuiFormLabel-root, & .MuiInputBase-root, & .MuiSelect-root, & .MuiMenuItem-root": {
            color: theme.palette.text.primary,
        }, "& .MuiInputBase-input, & .MuiInputLabel-root, & .MuiTableSortLabel-root, & .MuiTableSortLabel-icon": {
            color: theme.palette.text.primary + " !important",
        }, "& .MuiTableCell-root": {
            paddingTop: 6,
            paddingBottom: 6,
        } }, (theme.palette.type === "dark"
        ? {
            "& .MuiTypography-root, & .MuiTypography-colorTextSecondary, & .MuiFormLabel-root, & .MuiInputLabel-root, & .MuiInputBase-root, & .MuiInputBase-input, & .MuiSelect-root, & .MuiTableCell-root, & .MuiTableSortLabel-root, & .MuiTableSortLabel-icon, & .MuiListItemText-primary, & .MuiListItemText-secondary, & .MuiBreadcrumbs-root, & .MuiBreadcrumbs-li, & .MuiLink-root": {
                color: "rgba(255, 255, 255, 0.92) !important",
            },
            "& .MuiButton-textPrimary, & .MuiButton-outlinedPrimary, & .MuiButton-outlinedSecondary, & .MuiIconButton-colorPrimary, & .MuiSvgIcon-colorPrimary": {
                color: "#fff !important",
            },
            "& .MuiButton-outlined, & .MuiButton-outlinedPrimary, & .MuiButton-outlinedSecondary": {
                color: "#fff !important",
                borderColor: "rgba(255, 255, 255, 0.62) !important",
            },
            "& .MuiButton-outlined:hover, & .MuiButton-outlinedPrimary:hover, & .MuiButton-outlinedSecondary:hover": {
                color: "#fff !important",
                borderColor: "#fff !important",
                backgroundColor: "rgba(255, 255, 255, 0.1) !important",
            },
            "& .MuiButton-root.Mui-disabled": {
                color: "rgba(255, 255, 255, 0.38) !important",
                borderColor: "rgba(255, 255, 255, 0.22) !important",
            },
            "& .MuiCheckbox-root, & .MuiRadio-root, & .MuiSvgIcon-root": {
                color: "rgba(255, 255, 255, 0.86)",
            },
            "& .MuiInput-underline:before": {
                borderBottomColor: "rgba(255, 255, 255, 0.42)",
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "rgba(255, 255, 255, 0.7)",
            },
            "& .MuiInput-underline:after": {
                borderBottomColor: "#fff",
            },
        }
        : {})), { "& .MuiTableCell-sizeSmall": {
            paddingTop: 4,
            paddingBottom: 4,
        }, "& .MuiIconButton-sizeSmall": {
            padding: 4,
        } }),
}); });
export var AdminLayout = function (_a) {
    var children = _a.children, _b = _a.breadcrumbs, breadcrumbs = _b === void 0 ? true : _b;
    var theme = useTheme();
    var classes = useStyles();
    var showPermanentDrawer = useMediaQuery(theme.breakpoints.up("md"));
    var _c = React.useState(false), showDrawer = _c[0], setShowDrawer = _c[1];
    var _d = useThemeMode(), mode = _d.mode, toggleMode = _d.toggleMode;
    return (React.createElement(Box, { display: "flex" },
        React.createElement(CssBaseline, null),
        React.createElement(AppBar, { position: "absolute", color: "inherit", className: classes.appBar },
            React.createElement(Toolbar, { className: classes.toolbar },
                React.createElement(Hidden, { mdUp: true },
                    React.createElement(IconButton, { onClick: function () { return setShowDrawer(!showDrawer); } },
                        React.createElement(Menu, null))),
                React.createElement(Box, { display: "flex", ml: "auto", alignItems: "center" },
                    React.createElement(Tooltip, { title: mode === "dark" ? "Включить светлый режим" : "Включить темный режим" },
                        React.createElement(IconButton, { onClick: toggleMode, color: "inherit" }, mode === "dark" ? React.createElement(Brightness7, null) : React.createElement(Brightness4, null)))))),
        React.createElement(Drawer, { variant: showPermanentDrawer ? "permanent" : "temporary", anchor: "left", classes: { root: classes.drawer, paper: classes.drawerPaper }, open: showDrawer, onClose: function () { return setShowDrawer(false); } },
            React.createElement(Box, null,
                React.createElement(RouterLink, { to: paths.admin.playlists.index() },
                    React.createElement(Box, { display: "inline-flex", alignItems: "center", justifyContent: "center" },
                        React.createElement(Logo, { width: "80%" })))),
            React.createElement(Divider, null),
            React.createElement(Navigation, null)),
        React.createElement(Box, { component: "main", className: classes.main },
            React.createElement(Toolbar, { className: classes.toolbar }),
            breadcrumbs && (React.createElement(Box, { mb: 2 },
                React.createElement(Breadcrumbs, null))),
            React.createElement(Box, { display: "flex", justifyContent: "center" },
                React.createElement(Box, { width: "100%", maxWidth: 1200 }, children))),
        React.createElement(Player, null)));
};
